// extracted by mini-css-extract-plugin
export default {"containerForm":"styles_containerForm__4A2Bf","previewImg":"styles_previewImg__KGeGP","errorImgUrl":"styles_errorImgUrl__tUmQr","switch":"styles_switch__ewVOn"};